import { render, staticRenderFns } from "./TgFooterBar.vue?vue&type=template&id=4f6065c0&"
import script from "./TgFooterBar.vue?vue&type=script&lang=js&"
export * from "./TgFooterBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports